import { useState } from "react";

export function useUnsavedChangesGuard(hasUnsavedChanges: boolean) {
  const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);

  const guard = (action: () => void) => {
    if (!hasUnsavedChanges) {
      action();
      return;
    }
    setPendingAction(() => action);
  };

  const alertProps = {
    hasUnsavedChanges,
    manualOpen: pendingAction !== null,
    onManualOpenChange: (open: boolean) => {
      if (!open) setPendingAction(null);
    },
    onManualLeave: () => {
      pendingAction?.();
      setPendingAction(null);
    },
  };

  return { guard, alertProps };
}
